var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonSlidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 24,
    fill: "#3C3C3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 36,
    width: 48,
    height: 10,
    rx: 5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 59,
    width: 48,
    height: 10,
    rx: 5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 82,
    width: 48,
    height: 10,
    rx: 5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 35.5,
    width: 11,
    height: 11,
    rx: 4.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 58.5,
    width: 11,
    height: 11,
    rx: 4.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 81.5,
    width: 11,
    height: 11,
    rx: 4.5,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSlidebar);
export default __webpack_public_path__ + "static/media/button-slidebar.f991a6964c244e5489a462c05515b30c.svg";
export { ForwardRef as ReactComponent };